/* Partner Hero */
import Flickity from 'flickity'

export default function partnerHero () {
  const slider = document.querySelector('.partner__hero-slides')
  if (!slider) return
  const slides = slider.querySelectorAll('.partner__hero-slide')
  if (slides.length < 2) return
  const captions = document.querySelectorAll('.partner__hero-caption')
  const flickity = new Flickity(slider, {
    wrapAround: true,
    prevNextButtons: false,
  })
  flickity.on('change', function (index) {
    for (let i = 0; i < captions.length; i++) {
      if (i === index) {
        captions[i].classList.add('visible')
      } else {
        captions[i].classList.remove('visible')
      }
    }
  })
}
